import { render, staticRenderFns } from "./EditLiteralEditor.vue?vue&type=template&id=0cf1efc6&scoped=true&"
import script from "./EditLiteralEditor.vue?vue&type=script&lang=js&"
export * from "./EditLiteralEditor.vue?vue&type=script&lang=js&"
import style0 from "./EditLiteralEditor.vue?vue&type=style&index=0&id=0cf1efc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf1efc6",
  null
  
)

export default component.exports